function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import LightbulbOutline from "../../icons/LightbulbOutline";
//Limitless imports
import SystemDialogue from "../system-dialogue/SystemDialogue";
const useStyles = makeStyles(({
  palette,
  typography
}) => {
  var _palette$dialogues$sy, _palette$dialogues, _palette$dialogues$sy2, _palette$dialogues$sy3, _palette$dialogues2, _palette$dialogues2$s, _palette$dialogues$sy4, _palette$dialogues3, _palette$dialogues3$s, _palette$dialogues$sy5, _palette$dialogues4, _palette$dialogues4$s;
  const background = (_palette$dialogues$sy = (_palette$dialogues = palette.dialogues) === null || _palette$dialogues === void 0 ? void 0 : (_palette$dialogues$sy2 = _palette$dialogues.system) === null || _palette$dialogues$sy2 === void 0 ? void 0 : _palette$dialogues$sy2.background) !== null && _palette$dialogues$sy !== void 0 ? _palette$dialogues$sy : palette.contrast.main;
  const text = (_palette$dialogues$sy3 = (_palette$dialogues2 = palette.dialogues) === null || _palette$dialogues2 === void 0 ? void 0 : (_palette$dialogues2$s = _palette$dialogues2.system) === null || _palette$dialogues2$s === void 0 ? void 0 : _palette$dialogues2$s.text) !== null && _palette$dialogues$sy3 !== void 0 ? _palette$dialogues$sy3 : palette.contrast.light;
  const borderRadius = (_palette$dialogues$sy4 = (_palette$dialogues3 = palette.dialogues) === null || _palette$dialogues3 === void 0 ? void 0 : (_palette$dialogues3$s = _palette$dialogues3.system) === null || _palette$dialogues3$s === void 0 ? void 0 : _palette$dialogues3$s.borderRadius) !== null && _palette$dialogues$sy4 !== void 0 ? _palette$dialogues$sy4 : 4;
  const systemInfoTextFont = (_palette$dialogues$sy5 = (_palette$dialogues4 = palette.dialogues) === null || _palette$dialogues4 === void 0 ? void 0 : (_palette$dialogues4$s = _palette$dialogues4.system) === null || _palette$dialogues4$s === void 0 ? void 0 : _palette$dialogues4$s.fontFamily) !== null && _palette$dialogues$sy5 !== void 0 ? _palette$dialogues$sy5 : typography.fontFamily;
  return {
    primaryBackground: {
      backgroundColor: background,
      borderRadius
    },
    primaryText: {
      color: text,
      fontFamily: systemInfoTextFont
    }
  };
});
const SystemInfoDialogue = ({
  ...rest
}) => {
  var _rest$dialogue;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(SystemDialogue, _extends({
    dialogueClasses: classes,
    body: (_rest$dialogue = rest.dialogue) === null || _rest$dialogue === void 0 ? void 0 : _rest$dialogue.body,
    Icon: /*#__PURE__*/React.createElement(LightbulbOutline, {
      className: classes.primaryText
    })
  }, rest));
};
export default SystemInfoDialogue;